/**
 * Which conversations get a chip, given every known one newest first: the
 * `limit` most recent, plus any older one with news (working, or a reply not
 * yet read). Nothing else on the bar would show that news, so the cap only
 * applies to conversations with nothing new.
 */
export function selectChipRows<Row>(rows: ReadonlyArray<Row>, limit: number, hasNews: (row: Row) => boolean): Row[] {
  return rows.filter((row, index) => index < limit || hasNews(row));
}
